module.exports = __webpack_public_path__ + "img/koma_maker_logo.aeaae202.svg";